var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.66667,
    height: 11.6667,
    rx: 0.833333,
    transform: "matrix(0 -1 -1 0 15.832 10.834)",
    fill: "#8DC63F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5906 14.4114C10.916 14.7368 10.916 15.2645 10.5906 15.5899C10.2651 15.9153 9.73748 15.9153 9.41205 15.5899L4.41205 10.5899C4.09657 10.2744 4.08553 9.76643 4.38701 9.43755L8.97034 4.43754C9.28133 4.09828 9.80847 4.07536 10.1477 4.38635C10.487 4.69735 10.5099 5.22449 10.1989 5.56375L6.15475 9.97559L10.5906 14.4114Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftGreen);
export default __webpack_public_path__ + "static/media/ArrowLeftGreen.001fa4de6b2a1aec1cc682597100b422.svg";
export { ForwardRef as ReactComponent };